import { getOrderTiming, parseReceivedTime } from "./orderTiming";

const rank = { neutral: 0, green: 1, orange: 2, red: 3 };

// The worst live line wins, regardless of how many other portions are on time.
export const getItemTiming = (entries = [], now = Date.now()) => {
  let worst = { tone: "neutral", label: "Timing unavailable", display: "—", description: "No valid receipt time or prep estimate." };
  let overdueQty = 0;
  let unknownQty = 0;
  entries.forEach((entry) => {
    if (!["PENDING", "IN_PROGRESS", "PROCESSING", "PREPARING"].includes(String(entry?.status || entry?.jobStatus || "").toUpperCase())) return;
    const quantity = Number(entry.quantity);
    if (!Number.isFinite(quantity) || quantity <= 0) return;
    const lineTiming = getOrderTiming(entry, now);
    if (lineTiming.tone === "red") overdueQty += quantity;
    if (lineTiming.tone === "neutral") unknownQty += quantity;
    const receipt = entry.earliestCreatedAt ?? entry.created;
    const timing = getOrderTiming({ ...entry, created: receipt }, now);
    const received = parseReceivedTime(receipt);
    const deadline = received == null || timing.prepMinutes == null ? Infinity : received + timing.prepMinutes * 60000;
    if (rank[timing.tone] > rank[worst.tone] ||
      (timing.tone === worst.tone && deadline < (worst.deadline ?? Infinity))) {
      worst = { ...timing, deadline };
    }
  });
  return { ...worst, overdueQty, unknownQty };
};
